import { AppThunkDispatch, AppThunkGetState } from '@Reducers/index';

import { UsersApiService } from '@ClientApi/users';
import { IUserExtension } from '@ClientModels/userExtension';

import { AddManagers, SetManagersLoading } from './managersAction';

export const ADD_USERS = 'ADD_USERS';
export const RESET_USERS = 'RESET_USERS';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_USERS_LOADING = 'SET_USERS_LOADING';

export class AddUsers {
  readonly type = ADD_USERS;

  constructor(public users: IUserExtension[]) {}
}

export class ResetUsers {
  readonly type = RESET_USERS;
}

export class RemoveUser {
  readonly type = REMOVE_USER;

  constructor(public user: IUserExtension) {}
}

export class SetUsersLoading {
  readonly type = SET_USERS_LOADING;

  constructor(public payload: boolean) {}
}

export const getAllUsers =
  (forceReload: boolean = false) =>
  async (dispatch: AppThunkDispatch, getState: AppThunkGetState) => {
    if (!forceReload) {
      const { usersLoading, users } = getState().users;
      if (usersLoading || users.length) {
        return;
      }
    }
    dispatch(new SetUsersLoading(true));
    dispatch(new SetManagersLoading(true));
    const users = await UsersApiService.getAll();
    const usersWithDisplayNames = users.map((user) => {
      return {
        ...user,
        displayName: user.name || user.email
      };
    });
    const managersWithDisplayNames = usersWithDisplayNames.filter(
      (user) =>
        user.is_active && (user.user_profile.can_manager_approve || user.user_profile.is_admin || user.user_profile.role === 'manager')
    );
    dispatch(new AddUsers(usersWithDisplayNames));
    dispatch(new AddManagers(managersWithDisplayNames));
    dispatch(new SetUsersLoading(false));
    dispatch(new SetManagersLoading(false));
  };

export const refreshUsersIfMissing = (userId: string) => async (dispatch: AppThunkDispatch, getState: AppThunkGetState) => {
  const user = getState().users.usersById[userId];
  if (!user) {
    dispatch(getAllUsers(true));
  }
};

export type UserAction = AddUsers | SetUsersLoading | RemoveUser | ResetUsers;
